import MediaInfoContent from './MediaInfoContent';

export default MediaInfoContent;
